import axios from 'axios'
import moment from 'moment'
import {cloneDeep} from 'lodash'
import getApiClient from '@/plugins/api-client'
import {cnpj, cpf} from 'cpf-cnpj-validator'
import course from '../../../../../dto/course'
import ibgeCityService from '@/services/ibgeCityService'
import {accentInsensitiveFilter, highlightParts} from '@/helpers/textNormalizerHelper'

export default {
    cityFilter: accentInsensitiveFilter,

    cityHighlight: highlightParts,

    setFormattedUserBirthDate: function (rawDate) {
        if (rawDate) {
            this.formattedUserBirthDate = moment(rawDate).format('DD/MM/YYYY')
        }
    },

    loadCitiesForState: async function (uf, callback = null) {
        const self = this
        if (!uf) {
            self.availableCities = []
            return
        }
        self.isLoadingCities = true
        const api = getApiClient(self.$store)
        const cities = await ibgeCityService.getCitiesByUf(api, uf)
        self.availableCities = cities
        self.isLoadingCities = false
        if (typeof callback === 'function') {
            callback(cities)
        }
    },

    onStateChange: function (newState) {
        const self = this
        if (!newState) {
            self.availableCities = []
            self.user.address.city = ''
            return
        }
        self.loadCitiesForState(newState, (cities) => {
            if (self.user.address.city && !cities.includes(self.user.address.city)) {
                self.user.address.city = ''
            }
        })
    },

    loadCurrentUserData: function () {
        const self = this,
            api = getApiClient(self.$store),
            user = self.$store.state.session.user

        const r = (Math.random() + 1).toString(36).substring(7);
        api.get(`users/${user.id}?${r}`)
            .then((result) => {
                self.user = self.normalizeUserData(result.data)
                if (self.user.address && self.user.address.state) {
                    self.loadCitiesForState(self.user.address.state)
                }
                if (self.user.cpf) {
                    self.isRegistered = true
                }

                if (! self.user.courses.length) {
                    self.appendCourse()
                }

                self.user.additionalLanguages = self.user.languages.filter(language => {
                    return !['english', 'spanish'].includes(language)
                })

                if (self.user.additionalLanguages.length) {
                    self.showAdditionalLanguagesSelection = true
                }

                self.$store.commit('setUserData', self.user)
            })
    },

    setUserBirthDate: function () {
        let birthDate = this.formattedUserBirthDate.split('/'),
            year = birthDate[2],
            month = birthDate[1],
            day = birthDate[0]

        let formattedDate = `${year}-${month}-${day}`

        if (moment(formattedDate).isValid()) {
            this.user.birthDate = formattedDate
        } else {
            this.formattedUserBirthDate = ''
        }
    },

    loadAddressByZipCode: function () {
        const self = this,
            zipCode = self.user.address.zipCode.replace(/[^0-9]/g, ''),
            endpoint = `https://viacep.com.br/ws/${zipCode}/json/`

        if (zipCode.length === 8) {
            self.$store.commit('startLoading')
            axios.get(endpoint)
                .then((result) => {
                    let data = result.data
                    if (data && !data.erro) {
                        self.user.address.street = data.logradouro || self.user.address.street
                        self.user.address.neighbourhood = data.bairro || self.user.address.neighbourhood
                        self.user.address.state = data.uf
                        if (data.uf) {
                            self.loadCitiesForState(data.uf, (cities) => {
                                if (data.localidade) {
                                    const matched = (cities || []).find(c => c.localeCompare(data.localidade, undefined, { sensitivity: 'accent' }) === 0)
                                        || (cities || []).find(c => c.localeCompare(data.localidade, undefined, { sensitivity: 'base' }) === 0)
                                    self.user.address.city = matched || ''
                                } else {
                                    self.user.address.city = ''
                                }
                            })
                        } else {
                            self.user.address.city = ''
                        }
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                    self.$store.commit('stopLoading')
                })
        }
    },

    updatePersonalData: function () {
        const self = this,
            api = getApiClient(self.$store),
            user = self.$store.state.session.user,
            route = self.$route.name

        self.resetFormMessages()

        let postData = self.reduceUserPostData(),
            params = ''

        if (route === 'ProfessionalRegister') {
            params = '?newUser=true'
        }

        api.patch(`professional/register/${user.id}${params}`, postData, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then((result) => {
                let data = result.data
                if (data.address) {
                    self.user.address['@id'] = data.address['@id']
                }
                if (data.company) {
                    self.user.company['@id'] = data.company['@id']
                }

                if (data.courses) {
                    self.user.courses = data.courses
                }

                if (data.vaccinationCertificateUrl) {
                    self.user.vaccinationCertificateUrl = data.vaccinationCertificateUrl
                }
                self.user.password = ''
                self.user.passwordConfirmation = ''

                self.isRegistered = true
                self.$store.commit('setUserData', data)

                self.user.languages = data.languages
                self.user.additionalLanguages = self.user.languages.filter(language => {
                    return !['english', 'spanish'].includes(language)
                })

                if (self.user.additionalLanguages.length) {
                    self.showAdditionalLanguagesSelection = true
                }

                switch (self.$route.name) {
                    case 'ProfessionalRegister':
                        self.showSuccessMessage('Dados salvos! Continue seu cadastro')
                        break;
                    default:
                        self.showSuccessMessage('Dados salvos!')
                        break;
                }
            })
            .catch((error) => {
                let response = error.response
                switch (response.status) {
                    case 400:
                    case 422:
                        if (error.response.data.violations) {
                            error.response.data.violations.forEach((violation) => {
                                self.errors[violation.propertyPath] = violation.message
                            })

                            if (['xs', 'sm'].includes(self.$vuetify.breakpoint.name)) {
                                window.setTimeout(() => {
                                    const firstError = document.querySelector('.v-messages.error--text:first-of-type')
                                    if (firstError) {
                                        let top = firstError.offsetTop
                                        self.$vuetify.goTo(top)
                                    }
                                }, 250)
                            }
                        }
                        break;
                }
                self.showErrorMessage('Falha ao salvar os dados. Verifique os campos e tente novamente.')
            })
    },

    resetFormMessages: function () {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = ''
        })
    },

    reduceUserPostData: function () {
        const self = this,
            user = self.user,
            postData = cloneDeep(user)

        if (!postData.birthDate) {
            postData.birthDate = new Date()
        }

        if (postData.address['@id']) {
            postData.address.id = postData.address['@id']
        }

        if (postData.company['@id']) {
            postData.company.id = postData.company['@id']
        }

        if (!postData.company.name && !postData.company.cnpj) {
            delete postData['company']
        }

        if ((postData.photo && !postData.photo.match(/base64/g)) || !postData.photo) {
            self.$delete(postData, 'photo')
        }

        if (! postData.password) {
            self.$delete(postData, 'password')
            self.$delete(postData, 'passwordConfirmation')
        }

        if (postData.vaccinationCertificateFile) {
            self.$delete(postData, 'vaccinationCertificateFile')
        }

        if (! postData.vaccinationCertificate) {
            self.$delete(postData, 'vaccinationCertificate')
        }

        for (let courseIndex in postData.courses) {
            let course = postData.courses[courseIndex]
            if (!course.name && !course.school) {
                self.$delete(postData.courses, courseIndex)
            }

            if (course['@id']) {
                course.id = course['@id']
            }
        }

        postData.languages = postData.languages.filter(language => {
            return ['english', 'spanish'].includes(language)
        })

        postData.languages = [...new Set(postData.languages.concat(postData.additionalLanguages))]

        delete postData['symplaParticipations']

        return postData
    },

    normalizeUserData: function (userData) {
        if (Array.isArray(userData.socialNetworks)) {
            userData.socialNetworks = {}
        }

        const self = this,
            user = self.user,
            localData = cloneDeep(user),
            mergedObject = Object.assign(localData, userData)

        self.setFormattedUserBirthDate(mergedObject.birthDate)

        return mergedObject
    },

    showErrorMessage: function (message) {
        const self = this

        self.errorMessage.content = message
        self.errorMessage.show = true
    },

    showSuccessMessage: function (message) {
        const self = this

        self.successMessage.content = message
        self.successMessage.show = true

        if (self.$route.name === 'ProfessionalRegister') {
            self.successModal = true
        }
    },

    nextStep: function () {
        const self = this

        self.successModal = false
        self.$router.push({name: 'ProfessionalWorkProfiles'})
    },

    validateVaccinationCertificate: function (file) {
        this.errors.vaccinationCertificate = ''

        if (file) {
            if (!['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type)) {
                this.errors.vaccinationCertificate = 'Formato inválido'
                return 'Formato inválido'
            }

            if (file.size > 500000) {
                this.errors.vaccinationCertificate = 'Tamanho máximo: 500kb'
                return 'Tamanho máximo: 500kb'
            }
        }

        return true
    },

    updateVaccinationCertificate: function() {
        let file = this.user.vaccinationCertificateFile

        this.validateVaccinationCertificate(file)
        if (this.errors.vaccinationCertificate) {
            file = null
        }
        if (file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.user.vaccinationCertificate = e.target.result
            };
            reader.readAsDataURL(file);

            return
        }

        this.deleteVaccinationCertificate()
    },

    deleteVaccinationCertificate: function() {
        this.user.vaccinationCertificate = null
        this.user.vaccinationCertificateUrl = null
        this.user.vaccinationCertificateFile = null
    },

    startVaccinationCertificateUpload: function () {
        document.getElementById('registerVaccinationCertificate').click()
    },

    validateCpf: function (value) {
        if (value && value.length === 14) {
            return cpf.isValid(value) ? true : 'CPF inválido'
        }

        return true
    },

    validateCnpj: function (value) {
        if (value && value.length === 18) {
            return cnpj.isValid(value) ? true : 'CNPJ inválido'
        }

        return true
    },

    appendCourse() {
        const newCourse = {...course}

        this.user.courses.push(newCourse)
    }
}
